import { Component, OnInit, ViewChild } from '@angular/core';
import { LoadingController, NavParams } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { LocationWarningService } from 'src/app/services/location-warning/location-warning.service';
import { MenuStateService } from 'src/app/services/menu-state/menu-state.service';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ProgressingComponent } from '../../components/progressing/progressing.component';
import { Navigator } from 'src/app/services/routing/navigator';

@Component({
	selector: 'app-location-warning',
	templateUrl: './location-warning.component.html',
	styleUrls: ['./location-warning.component.scss'],
})

export class LocationWarningComponent implements OnInit {

	textContent: Record<string, string> = {};
	public loading: any;
	public isAuthenticated: boolean = false;
	canplayLink: string = '';

	@ViewChild(ProgressingComponent) progressingUI!: ProgressingComponent;

	constructor(
		private utils: UtilsService,
		private navigator: Navigator,
		private siteContentService: SiteContentService,
		private userSessionService: UserSessionService,
		private locationWarningService: LocationWarningService,
		private eventsService: EventsService,
		private appLinks: AppLinksService,
		public loadingController: LoadingController,
		private config: ConfigService,
		private navParams: NavParams
	) { }

	ngOnInit(): void {
		sessionStorage.setItem('locationWarningSeenByUser', 'true');
		this.canplayLink = this.config.getConfig().FEATURE_CANPLAY_SITE_LINK || "https://www.mohegansuncasino.com/";
	}

	ngAfterViewInit() {
		this.siteContentService
			.loadConfig('location_warning')
			.then((response: Record<string, string>) => {
				this.textContent = response;
			});
	}

	onStay() {
		// if(this.locationWarningService.getCurrentContext() === "join"){
		//   this.navigator.navigateTo('SignupStepOneComponent','',{connectBoydCardPath:false});  
		// }
		// if(this.locationWarningService.getCurrentContext() === "landing"){
		//   this.navigator.dismiss();
		// }
		// if(this.locationWarningService.getCurrentContext() === "register"){
		//   this.navigator.dismiss();
		// }
		// let callBackFn = this.navParams.get('callBackFn');
		// if (!!callBackFn) callBackFn();
		this.onClose();

	}

	goToCanplay() {
		this.appLinks.openExternalPage(this.canplayLink);
	}

	onClose = () => {
		let callBackFn = this.navParams.get('callBackFn');
		if (!!callBackFn) callBackFn();
		this.navigator.dismiss();
	}


}
